import { getFileIndex } from "@root/store/selectors/entities";
import { useSelector } from "react-redux";
import { DashBoardTextarea } from "./dashboardtextarea";
import { StayledInputContainer } from "./style";
import { useRef } from "react";

export function DashBoardInput({
  fileContainerRef,
  submitHandler,
  onChangehandler,
  input,
  onSubmit,
  loading = false,
  setInput,
  pid,
  name,
  px = 0,
  onChatbotDropdownMenuClose,
  onProjectChatbotDropdownMenuClose,
  ...props
}: any) {
  const inputRef: any = useRef(null);
  const fileIndex = useSelector(getFileIndex);

  return (
    <StayledInputContainer {...props} px={px}>
      <DashBoardTextarea
        onSubmit={onSubmit}
        fileIndex={fileIndex}
        onSend={submitHandler}
        inputRef={inputRef}
        onChangehandler={onChangehandler}
        input={input}
        loading={loading}
        name={name}
        pid={pid}
        onChatbotDropdownMenuClose={onChatbotDropdownMenuClose}
        onProjectChatbotDropdownMenuClose={onProjectChatbotDropdownMenuClose}
      />
    </StayledInputContainer>
  );
}
